import { render } from "./pickupReturnRequest.vue?vue&type=template&id=6423ccd0"
import script from "./pickupReturnRequest.vue?vue&type=script&lang=js"
export * from "./pickupReturnRequest.vue?vue&type=script&lang=js"

import "./pickupReturnRequest.vue?vue&type=style&index=0&id=6423ccd0&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__